import React, { Component } from 'react';
import axios from 'axios';
import Loader from '../../Loader/Loader';

class ContactManagersMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            managers: [],
            loading: true,
        };
    }

    componentDidMount() {
        axios
            .get('https://www.krembo.org.il/wp-json/krembo/v1/management')
            .then((res) => {
                const managers = res.data.map((m) => ({
                    ManageImg: m.image,
                    ManageName: m.name,
                    ManageNameEn: m.name_en,
                    ManageEmail: m.email,
                    Manageposition: m.designation,
                    ManagepositionEn: m.designation_en,
                }));
                this.setState({ managers, loading: false });
            })
            .catch((err) => {
                console.error('Failed to load management contacts', err);
                this.setState({ loading: false });
            });
    }

    render() {
        const { lang, language } = this.props;
        const { managers, loading } = this.state;

        return (
            <div className="contact__managers__wrap">
                <h1>{lang.managers_h1}</h1>
                {loading && <Loader />}
                {managers.map((n, i) => (
                    <div className="contact__manager" key={i}>
                        <aside>
                            <img src={n.ManageImg} alt="" />
                            <span>
                                <h2>
                                    {language === 'hebrew'
                                        ? n.ManageName
                                        : n.ManageNameEn}
                                </h2>
                                <h3>
                                    {language === 'hebrew'
                                        ? n.Manageposition
                                        : n.ManagepositionEn}
                                </h3>
                            </span>
                        </aside>

                        <a href={`mailto:${n.ManageEmail}`}>
                            <button>{lang.send}</button>
                        </a>
                    </div>
                ))}
            </div>
        );
    }
}

export default ContactManagersMap;
